<template>
    <div>
        <add-addresses-card
            v-if="showSaveCard"
            :selected-addresses="selectedAddresses"
            :delivery-project="deliveryProject"
        />
        <div class="overflow-x-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th width="60">
                            <checkbox-input
                                v-model="allAddressesSelected"
                                class="mr-md"
                                @toggle="toggleAllSelected"
                            />
                        </th>
                        <th width="40%">Adress</th>
                        <th>Säljprojekt</th>
                    </tr>
                </thead>
                <tbody>
                    <address-item
                        v-for="address in addresses.data"
                        :key="address.id"
                        :delivery-project="deliveryProject"
                        :address="address"
                        @toggleAddressSelected="toggle"
                    />
                </tbody>
            </table>
        </div>
        <add-addresses-card
            v-if="showSaveCard"
            :selected-addresses="selectedAddresses"
            :delivery-project="deliveryProject"
        />
    </div>
</template>

<script>
    import AddressItem from './AddressItem';
    import AddAddressesCard from './AddAddressesCard';

    export default {
        components: { AddressItem, AddAddressesCard },
        props: {
            addresses: {
                required: true,
                type: Object, // paginator object
            },
            deliveryProject: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                selectedAddresses: [],
                allAddressesSelected: false,
            };
        },
        computed: {
            showSaveCard() {
                return this.selectedAddresses.length > 0;
            },
        },
        methods: {
            toggleAllSelected() {
                this.selectedAddresses = [];
                EventBus.$emit('all-addresses-toggled', this.allAddressesSelected);
            },
            toggle(address, selected) {
                if (selected) {
                    this.selectedAddresses.push(address);
                } else {
                    const index = this.selectedAddresses.findIndex(a => a.id === address.id);
                    this.selectedAddresses.splice(index, 1);
                }
            },
        },
    };
</script>
